// Generated by tools/as3-to-ts from work/decomp/main/scripts/FWP.as (FWP.init_data_arrays, line 2109); hand-edits allowed (see docs/architecture.md)

/** `this.LEAGUE_THRESHOLD` literal from FWP.init_data_arrays. Returns a fresh copy on every call (the game mutates it). */
export function create_LEAGUE_THRESHOLD(): any {
  return new Array<any>(0, 0, 1000, 2000, Number.POSITIVE_INFINITY);
}
